/* eslint-disable react/prop-types */
import React from 'react';
import './style.scss';

const Budget = (props) => {
  const { totalBalance, currencyOptions } = props;

  return (
    <div className="budget sticky">
      <div>
        <h3>
          Your balance:{' '}
          <span 
          className={(totalBalance > 0) ? 'budget green' : 'budget red'}
          >
            {totalBalance.toLocaleString(undefined, currencyOptions) || '0'}
          </span>
        </h3>
      </div>
    </div>
  );
};

export default Budget;
